import { get } from 'lodash';
import cmsAbstractMixin from 'framework/mixins/cms/cms-abstract';


export default {
    mixins: [
        cmsAbstractMixin,
    ],
    props: {
        plugin: Object,
    },
    data() {
        return {
            cmsCfg: {
                watchPath: 'plugin.cms',
                type: 'plugin',
            },
        };
    },
    computed: {
        plugins() {
            return get(this, 'plugin.plugins', []);
        },
        content() {
            return get(this, 'plugin.content', {});
        },
        cmsEditHelperAttrs() {
            const isEditable = (this.cmsReady && this.cmsComponentData);

            return isEditable ? {
                'data-cms-plugin-edit-helper': true,
                'data-cms-plugin-name': get(this, 'plugin.cms[1].plugin_name'),
            } : {};
        },
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/cms/cms-plugin/index.js